import {Locations} from "./Locations";

export class List {

  constructor(container, eventEmitter, locations) {
    const self = this;
    this.$container =  $(container);
    this.eventEmitter = eventEmitter;
    this.activeLocation = null;
    this.locations = locations;
    $('.locations-wrap .map-wrap .list-scrollbar, .get-care-now-wrap .map-wrap .list-scrollbar').mCustomScrollbar();

    // *** Result row clicked starts ***
    this.eventEmitter.on('location', function(e) {
      if (self.activeLocation === e.location) {
        self.activeLocation = null;
        self.deactivateRows();
        return;
      }
      self.activeLocation = e.location;
      self.deactivateRows();
      if (self.activeLocation !== null) {
        const $row = self.$container.find(`[data-location-id=${self.activeLocation.nid}]`);
        $row.addClass('active');
        $row.find('.inner-wrap').stop().slideDown();
      }
    });
    // *** Result row clicked ends ***

    this.locations.forEach(location => {
      self.$container.append(self.createRow(location));
    });
  }

  deactivateRows() {
    const $row = this.$container.find('[data-location-id].active');
    $row.removeClass('active');
    $row.find('.inner-wrap').stop().slideUp();
  }

  createRow(location) {
    const self = this;
    const columnLeft = [
      `<address>${Locations.formatAddress(location.address)}</address>`,
      `<div class="phone"><a href="tel:${location.phone}">${location.phone}</a></div>`,
    ];
    if (location.directions) {
      columnLeft.push(`<a class="directions" href="${location.directions}">Get Directions</a>`);
    }
    const columnRight = [
      Locations.renderCurrentDaySchedule(location),
      `<div class="daily-schedule">${Locations.renderDailySchedule(location)}</div>`,
    ];
    const appointment = location.openSchedulingUrl ? `<a class="appointment" href="${location.openSchedulingUrl}">Schedule a Primary Care Appointment</a>` : '';
    const acceptingPatients = location.acceptingNewPatients ? `<div class="new-patients"><span>Accepting New Patients</span></div>` : '';
    const offersTelemedicine = location.offersTelemedicine
                                  ? `<div class="offers-telemedicine">
                                      <span class="offers-telemedicine--label">Also offers Telemedicine</span>
                                      <div class="tooltip-wrap" data-field-name="telemedicine">
                                        <span>Offers Telemedicine</span>
                                        <span aria-label="Telemedicine video visits make it easier to find care at a time and location that is convenient for you. Telemedicine appointments are available for both new patient visits and follow-ups.">Information Icon</span>
                                        <div class="tooltip">
                                            Telemedicine video visits make it easier to find care at a time and location that is convenient for you. Telemedicine appointments are available for both new patient visits and follow-ups.
                                        </div>
                                      </div>
                                    </div>`
                                  : '';
    let html = `
          <div class="location" data-location-id="${location.nid}">
            <h3 data-title>${location.title}</h3>
            <span class="location-type">${location.locationType}</span>
            <div class="inner-wrap">
              <div class="content-wrap">
                <div class="column-left">
                  ${acceptingPatients}
                  ${columnLeft.join('')}
                </div>
                <div class="column-right">${columnRight.join('')}</div>
                ${offersTelemedicine}
                ${appointment}
                <a class="details" href="${location.url}">View Location Details</a>
              </div>
            </div>
          </div>
          `;
    const $row = $(html);
    $('[data-title]', $row).click(function(){
      self.eventEmitter.trigger(jQuery.Event('location', {location: location}));
    });
    $('.current button', $row).click(function(){
      const $this = $(this);
      $this.parent().siblings('.daily-schedule').slideToggle();
      $this.toggleClass('active');
    });
    // $('[data-location-id].active [data-title]', $row).click(function(){
    //   const $this = $(this);
    //   $this.siblings('.inner-wrap').slideUp();
    //   $this.parent('.location.active').removeClass('active');
    // });
    return $row;
  }

}
